import React from "react";
import PostCategoryBadge from "../../../../components/PostCategoryBadge";
import RatingBar from "../RatingBar";

function PostContent({ post }) {
  const { title, description, caseType, category } = post;
  return (
    <article className="-card-content">
      <h2 className="-card-title"> {title} </h2>
      <p className="-card-meta"> {description} </p>
      <PostCategoryBadge category={category} caseType={caseType} />
      {!post.isLoading && <RatingBar post={post} />}
    </article>
  );
}

export default PostContent;



// WEBPACK FOOTER //
// ./src/components/Post/Components/PostContent/index.js